import { useRef, useEffect } from 'react'
import { useSelector } from 'statux'
import RegistrationForm from '../../../components/RegistrationForm/RegistrationForm'
import RichText from '../../../components/RichText/RichText'

export default function Registration (props = {
    heading: null,
    richText: null,
    disclaimer: null,
    img: {
        src: null,
        alt: null,
        width: null,
        height: null
    },
    registrationForm: null
}) {
    const user = useSelector('user')

    const section = useRef()

    const skipTo = useRef()

    const registrationForm = props.registrationForm || {}

    registrationForm.submitBtnSecondaryStyle = true

    useEffect(() => {
        if (!section.current
                || !skipTo.current)
            return

        const nextSection = section.current.nextSibling
            || document.querySelector('footer')

        const nextHeading = nextSection
            ? nextSection.querySelector('h2')
            : null

        const focusEl = nextHeading || nextSection

        if (!focusEl)
            return

        if (!focusEl.id)
            focusEl.id = 'registration-skip-to-target'

        if (skipTo.current.getAttribute('href')
                === `#${focusEl.id}`)
            return

        skipTo.current
            .setAttribute('href', `#${focusEl.id}`)
    }, [section.current])

    if (user)
        return null

    const isImg = props.img
        && props.img.src

    const isMultiCol = isImg
        || props.heading
        || props.richText
        || props.disclaimer

    return (
        <section
            ref={section}
            id="registration"
            className="registration pad-section theme-dark"
            tabIndex="-1"
        >
            <div className="container">
                <div
                    className={`row flex-justify-content-${isMultiCol
                        ? 'space-between'
                        : 'center'}`}
                >
                    {isMultiCol
                        && (
                            <div
                                className={`registration-content col-12 col-4-lg-up pad-4-r-lg pad-4-r-md-down${
                                    isImg
                                        && ' pad-3-t-md'}`}
                            >
                                <div
                                    className={isImg
                                        ? 'col-6-md pad-0-md'
                                        : null}
                                >
                                    {props.heading
                                        && (
                                            <h2 className="text-underscore">
                                                {props.heading}
                                            </h2>)}
                                    {props.richText
                                        && (
                                            <RichText
                                                className="body-2"
                                                html={props.richText}
                                                style={{ color: '#fff' }}
                                            />)}
                                    {props.disclaimer
                                        && (
                                            <p className="registration-disclaimer">
                                                {props.disclaimer}
                                            </p>)}
                                </div>
                                {isImg
                                    && (
                                        <div className="registration-gfx">
                                            <img
                                                src={props.img.src}
                                                alt={props.img.alt || ''}
                                                width={props.img.width}
                                                height={props.img.height}
                                            />
                                        </div>
                                    )}
                            </div>
                        )}
                    <div className="col-12 col-8-lg col-7-xl-up">
                        <a
                            ref={skipTo}
                            href="#"
                            className="skip-to margin-b"
                        >
                            Skip {(registrationForm || {}).role === 'member'
                                ? 'application'
                                : 'registration'}
                        </a>
                        <div
                            className="card"
                        >
                            <RegistrationForm {...registrationForm} />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
